var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enhancement"},[_c('FtaUpload',_vm._g(_vm._b({ref:"upload",attrs:{"limit":_vm.limit},nativeOn:{"click":function($event){return _vm.handleTrackTap.apply(null, arguments)}},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},'FtaUpload',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }